// extracted by mini-css-extract-plugin
export default {"b":"sun_b__cGuuK","h":"sun_h__odmCh","s2":"sun_s2__JOqLh","mar":"sun_mar__KfUXG","icon":"sun_icon__TsK+c","text":"sun_text__S4Yb8"};